import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const About = () => {
  const { t } = useTranslation();

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section
      id="about"
      style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #000000 100%)',
        padding: '100px 20px',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Decoración de fondo */}
      <div
        style={{
          position: 'absolute',
          top: '-50%',
          right: '-10%',
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(204, 0, 51, 0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          pointerEvents: 'none'
        }}
      />

      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          {/* Header */}
          <motion.div
            variants={itemVariants}
            className="text-center mb-5"
          >
            <div
              style={{
                background: '#cc0033',
                color: 'white',
                padding: '8px 20px',
                fontSize: '0.85rem',
                fontWeight: '600',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: '30px',
                display: 'inline-block'
              }}
            >
              {t('about.tag')}
            </div>
          </motion.div>

          {/* Contenido principal */}
          <div className="row justify-content-center">
            {/* Información personal */}
            <div className="col-lg-10 col-xl-8 text-center">
              <motion.h2
                variants={itemVariants}
                style={{
                  fontSize: '2.5rem',
                  fontWeight: '700',
                  color: 'white',
                  marginBottom: '15px',
                  fontFamily: 'Montserrat, sans-serif'
                }}
              >
                {t('about.name')}
              </motion.h2>

              <motion.h4
                variants={itemVariants}
                style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  color: '#cc0033',
                  marginBottom: '25px'
                }}
              >
                {t('about.role')}
              </motion.h4>

              <motion.p
                variants={itemVariants}
                style={{
                  fontSize: '1.05rem',
                  color: '#ccc',
                  lineHeight: '1.8',
                  marginBottom: '20px'
                }}
              >
                {t('about.description')}
              </motion.p>

              <motion.p
                variants={itemVariants}
                style={{
                  fontSize: '1.05rem',
                  color: '#ccc',
                  lineHeight: '1.8',
                  marginBottom: '30px'
                }}
              >
                {t('about.passion')}
              </motion.p>

              {/* Botón CTA */}
              <motion.a
                href="#contact"
                variants={itemVariants}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                style={{
                  display: 'inline-block',
                  padding: '14px 32px',
                  background: 'linear-gradient(135deg, #cc0033 0%, #a60029 100%)',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '8px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  boxShadow: '0 4px 15px rgba(204, 0, 51, 0.3)',
                  transition: 'all 0.3s ease'
                }}
              >
                {t('about.cta')}
              </motion.a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;